/* tslint:disable */
/* eslint-disable */

/**
 * 0 = None
 * 1 = X
 * 1 = Spatial1
 * 2 = Y
 * 2 = Spatial2
 * 3 = XY
 * 4 = Spatial3
 * 4 = Z
 * 7 = XYZ
 * 8 = Spatial4
 * 16 = Spatial5
 * 32 = Spatial6
 * 64 = Spatial7
 * 128 = Spatial8
 * 256 = Spatial9
 * 512 = Spatial10
 * 1024 = Spatial11
 * 2048 = Spatial12
 * 4096 = Spatial13
 * 8192 = Spatial14
 * 16384 = Spatial15
 * 32768 = Spatial16
 * 65535 = AllSpatialOrdinates
 * 65536 = Measure1
 * 65536 = M
 * 65539 = XYM
 * 65543 = XYZM
 * 131072 = Measure2
 * 262144 = Measure3
 * 524288 = Measure4
 * 1048576 = Measure5
 * 2097152 = Measure6
 * 4194304 = Measure7
 * 8388608 = Measure8
 * 16777216 = Measure9
 * 33554432 = Measure10
 * 67108864 = Measure11
 * 134217728 = Measure12
 * 268435456 = Measure13
 * 536870912 = Measure14
 * 1073741824 = Measure15
 * -2147483648 = Measure16
 * -65536 = AllMeasureOrdinates
 * -1 = AllOrdinates
 */
export enum Ordinates {
  None = 0,
  X = 1,
  Spatial1 = 1,
  Y = 2,
  Spatial2 = 2,
  XY = 3,
  Spatial3 = 4,
  Z = 4,
  XYZ = 7,
  Spatial4 = 8,
  Spatial5 = 16,
  Spatial6 = 32,
  Spatial7 = 64,
  Spatial8 = 128,
  Spatial9 = 256,
  Spatial10 = 512,
  Spatial11 = 1024,
  Spatial12 = 2048,
  Spatial13 = 4096,
  Spatial14 = 8192,
  Spatial15 = 16384,
  Spatial16 = 32768,
  AllSpatialOrdinates = 65535,
  Measure1 = 65536,
  M = 65536,
  XYM = 65539,
  XYZM = 65543,
  Measure2 = 131072,
  Measure3 = 262144,
  Measure4 = 524288,
  Measure5 = 1048576,
  Measure6 = 2097152,
  Measure7 = 4194304,
  Measure8 = 8388608,
  Measure9 = 16777216,
  Measure10 = 33554432,
  Measure11 = 67108864,
  Measure12 = 134217728,
  Measure13 = 268435456,
  Measure14 = 536870912,
  Measure15 = 1073741824,
  Measure16 = -2147483648,
  AllMeasureOrdinates = -65536,
  AllOrdinates = -1
}
